import React, { createContext, useContext, useEffect, useState } from 'react';
import { getContent } from '@/lib/api';

const SiteContext = createContext({ site: null, hero: null, loading: true });

export const SiteProvider = ({ children }) => {
  const [site, setSite] = useState(null);
  const [hero, setHero] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let mounted = true;
    Promise.all([getContent('site'), getContent('hero')])
      .then(([s, h]) => {
        if (!mounted) return;
        setSite(s);
        setHero(h);
      })
      .catch(() => {})
      .finally(() => mounted && setLoading(false));
    return () => {
      mounted = false;
    };
  }, []);

  return (
    <SiteContext.Provider value={{ site, hero, loading }}>{children}</SiteContext.Provider>
  );
};

export const useSite = () => useContext(SiteContext);
